import { render, staticRenderFns } from "./ProgramUpdate.vue?vue&type=template&id=2d4783ae&scoped=true"
import script from "./ProgramUpdate.vue?vue&type=script&lang=js"
export * from "./ProgramUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProgramUpdate.vue?vue&type=style&index=0&id=2d4783ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4783ae",
  null
  
)

export default component.exports